import { createSlice } from "@reduxjs/toolkit";

const getCount = (items) => {
  return items.reduce(
    (total, item) => total + (Number(item.qty) || 0),
    0
  );
};

const initialState = {
  // Normal Cart
  cartItems: [],
  cartCount: 0,

  // Coming Soon / Pre Cart
  preCartItems: [],
  preCartCount: 0,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,

  reducers: {
    // =========================
    // NORMAL CART
    // =========================
    addToCart: (state, action) => {
      const product = action.payload;
      const addQty = Number(product.qty) || 1;

      const exist = state.cartItems.find(
        (item) => item.product_id === product.product_id
      );

      const stock = Number(product.stock) || 0;

      if (exist) {
        const currentQty = Number(exist.qty) || 0;

        if (currentQty >= stock) {
          return;
        }

        exist.qty = Math.min(currentQty + addQty, stock);
        exist.stock = stock;
      } else {
        if (stock <= 0) {
          return;
        }

        state.cartItems.push({
          ...product,
          qty: Math.min(addQty, stock),
        });
      }

      state.cartCount = getCount(state.cartItems);
    },

    removeCart: (state, action) => {
      state.cartItems = state.cartItems.filter(
        (item) => item.product_id !== action.payload
      );

      state.cartCount = getCount(state.cartItems);
    },

    clearCart: (state) => {
      state.cartItems = [];
      state.cartCount = 0;
    },

    setCartItems: (state, action) => {
      state.cartItems = action.payload || [];
      state.cartCount = getCount(state.cartItems);
    },

    setCartCount: (state, action) => {
      state.cartCount = Number(action.payload) || 0;
    },

    // =========================
    // PRE / COMING SOON CART
    // =========================
    addPreCart: (state, action) => {
      const product = action.payload;
      const addQty = Number(product.qty) || 1;

      const exist = state.preCartItems.find(
        (item) => item.product_id === product.product_id
      );

      if (exist) {
        exist.qty = (Number(exist.qty) || 0) + addQty;
      } else {
        state.preCartItems.push({
          ...product,
          qty: addQty,
        });
      }

      state.preCartCount = getCount(state.preCartItems);
    },

    removePreCart: (state, action) => {
      state.preCartItems = state.preCartItems.filter(
        (item) => item.product_id !== action.payload
      );

      state.preCartCount = getCount(state.preCartItems);
    },

    clearPreCart: (state) => {
      state.preCartItems = [];
      state.preCartCount = 0;
    },

    setPreCartItems: (state, action) => {
      state.preCartItems = action.payload || [];
      state.preCartCount = getCount(state.preCartItems);
    },

    setPreCartCount: (state, action) => {
      state.preCartCount = Number(action.payload) || 0;
    },
  },
});

export const {
  // Normal cart
  addToCart,
  removeCart,
  clearCart,
  setCartItems,
  setCartCount,

  // Coming Soon cart
  addPreCart,
  removePreCart,
  clearPreCart,
  setPreCartItems,
  setPreCartCount,
} = cartSlice.actions;

export default cartSlice.reducer;
